type GlobalConfig =
    | "paymentChannels"
    | "topNotice"
    | "purchase"
    | "logistics"
    | "subscription"
    | "circle"
    | "notice";

const getPageDataProps = (
    layoutData: { pageData: any[]; config: Record<GlobalConfig, any> },
    componentName: string,
) => {
    const component = layoutData?.pageData?.find(
        (item) => item.name === componentName,
    );

    return component?.props;
};

export default getPageDataProps;
